<bb-page-header-ui
  title="This is the page title"
  subtitle="This is the page subtitle"
  navigationLinkText="Back to Dashboard"
  [primaryAction]="{ text: 'New card' }"
  [secondaryAction]="{ text: 'Add reminder', icon: 'access-alarms' }"
></bb-page-header-ui>
